import React from 'react';
import { makeStyles } from '@material-ui/core';


const useStyles = makeStyles(theme => ({
    '@global': {
        '*::-webkit-scrollbar': {
            width: '0.5em'
        },
        '*::-webkit-scrollbar-track': {
            // '-webkit-box-shadow': 'inset 0 0 6px #f1f1f1'
            backgroundColor: '#f1f1f1'
        },
        '*::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(0,0,0,.2)',
            borderRadius: '0.25em',
            outline: '1px solid slategrey'
        },
        // ':root': {
        //   scrollbarColor: 'rgba(0,0,0,0.2) #f1f1f1',
        //   scrollbarWidth: 'thin',
        // }
    }
}));


function CustomScrollbars(props) {
    const { children = null } = props;
    useStyles();

    return <>{children}</>;
}

export default CustomScrollbars;
